import React, { useState, useEffect, useRef } from 'react';
import propTypes from 'prop-types';
import { VIEWS } from './AiExperience.jsx';
import { LoadingScreen } from '_ui-core-js/React/components/LoadingScreen.jsx';
import { extractColorPalette } from '../../store/actions/artwork.js'
import { fireGTMTrackingEvent } from '_ui-core-js/utilities//fireGTMTrackingEvent.js';
import { CORE_GTM_TRACKING_VALUES } from '_ui-core-js/constants/analytics.js';
import { LBX_GTM_TRACKING_VALUES } from '../../constants/analytics.js';

export function ColorPaletteGenerationScreen(props) {

  const { data, state } = props;
  const colorPaletteHexValuesRef = useRef();
  const [colorPaletteGenerated, setColorPaletteGenerated] = useState(false);

  function proceedToColorPalettePresentation() {
    state.setColorPaletteHexValues(colorPaletteHexValuesRef.current)
    state.setActiveView(VIEWS.colorPalettePresentation.name);
  };

  useEffect(async () => {
    fireGTMTrackingEvent({
      name: CORE_GTM_TRACKING_VALUES.name.workflowEvent,
      componentName: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience, 
      componentGroup: CORE_GTM_TRACKING_VALUES.componentGroup.newCars,
      action: CORE_GTM_TRACKING_VALUES.action.workflowStep,
      label: CORE_GTM_TRACKING_VALUES.label.paletteGenerationLoadingScreen
    }, {
      workflow: {
        name: LBX_GTM_TRACKING_VALUES.componentName.lbxExperienceAiExperience,
        step: CORE_GTM_TRACKING_VALUES.label.paletteGenerationLoadingScreen,
        conversion: 0,
        variant: (state.loggedIn && state.instagramCode) ? 'instagram' : 'not-connected'
      }
    });

    try {
      const colourCombinations = await extractColorPalette(state.selectedColorPaletteImages);
      colorPaletteHexValuesRef.current = colourCombinations;
      setColorPaletteGenerated(true);
    } catch(error) {
      console.log(error)
    } 
  }, []);

  return (
    <LoadingScreen 
    text={data.loadingText}
    videoUrl={data.videoUrl} 
    loopVideo={true} 
    onLoadingCompletionCallback={proceedToColorPalettePresentation}
    loadingConditionsComplete={colorPaletteGenerated}
    backgroundCover={false}
    />
  )
};

ColorPaletteGenerationScreen.propTypes = {
  block: propTypes.string.isRequired,
  state: propTypes.object.isRequired,
  data: propTypes.object.isRequired
};
